export default "__VITE_ASSET__CQjGDYLD__"